
import Vue from 'vue';
import { mapState } from 'vuex';
import TicketCancelDialog from '../Employees/TicketCancelDialog.vue';
import MarkAsUsedDialog from '../Employees/MarkAsUsedDialog.vue';
import { datetimeFormatToAmericanFormat } from '../../lib/utils';

export default Vue.extend({
    components: {
        TicketCancelDialog,
        MarkAsUsedDialog,
    },
    props: {
        rideId: {
            type: Number,
            required: true,
        },
        onPassengersList: {
            type: Function,
        },
    },
    watch: {
        rideId() {
            this.getPassengersList();
        },
    },
    data() {
        return {
            loading: false,
            tableData: [],
            selectedTicket: { user_id: 0, ticketId: 0 },
            dialogDelete: false,
            dialogUsed: false,
            filters: {
                ticketStatus: 'all',
            },
            headers: [] as any,
        };
    },
    computed: {
        ...mapState('texts', ['ridesPassengetsList', 'tooltips']),
        ...mapState('corporate', ['hasHealthConsent']),
        ...mapState('tenants', ['tenants']),
    },
    methods: {
        datetimeFormatToAmericanFormat,
        markTicketAsUsed(item: any) {
            this.selectedTicket = item;
            this.dialogUsed = true;
        },
        cancelTicket(item: any) {
            this.selectedTicket = item;
            this.dialogDelete = true;
        },
        getPassengersList() {
            this.tableData = [];
            this.loading = true;
            this.$hipApi
                .getPassengersList(this.rideId)
                .then((res: any) => {
                    this.tableData = res;
                })
                .catch((err) => {
                    this.$notifier.showError(err?.error?.message || err?.message || err);
                })
                .finally(() => {
                    this.loading = false;
                    if (this.onPassengersList) {
                        this.onPassengersList(JSON.parse(JSON.stringify(this.tableData)));
                    }
                });
        },
        createTableHeaders() {
            this.headers = [
                {
                    text: 'Name',
                    value: 'fullName',
                    width: 300,
                },
                {
                    text: 'Email',
                    value: 'email',
                },
                {
                    text: 'Phone',
                    value: 'phone',
                },
                {
                    text: 'Pickup Stop',
                    value: 'PUstop',
                },
                {
                    text: 'Dropoff Stop',
                    value: 'DOstop',
                },
                {
                    text: 'Ticket Status',
                    value: 'ticketStatus',
                    filter: (value: string): boolean => {
                        if (this.filters.ticketStatus === 'all') return true;
                        return value === this.filters.ticketStatus;
                    },
                },
                {
                    text: 'Actions',
                    value: 'actions',
                    sortable: false,
                },
            ];
            if (this.hasHealthConsent) {
                this.headers.splice(6, 0, { text: 'Health', value: 'healthConsent' });
            }
            if (this.tenants.length > 0) {
                // insert tenant column right after the Email column
                const fieldIndex = this.headers.findIndex((h: any) => h.text === 'Email');
                this.headers.splice(fieldIndex + 1, 0, {
                    text: 'Tenant',
                    value: 'tenantId',
                    width: 300,
                });
            }
        },
        getTenantName(item: any): string {
            const tenant = this.tenants.find((t: any) => t.tenantId === item?.tenantId);
            return tenant ? tenant.firmName : null;
        },
    },
    created() {
        this.createTableHeaders();
        this.getPassengersList();
    },
});
